import { getRouteApi } from '@tanstack/react-router'
import { type DefaultValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import Loading from '@/components/Loading'
import BasicLayout from '@/components/common/BasicLayout/BasicLayout'
import { toast } from '@/hooks/useToast'
import queryClient from '@/queryClient'

import SchoolBreakForm from '../components/SchoolBreakForm'
import { type SchoolBreakFormPayload } from '../constants/school-break-payload'
import useAddSchooBreak from '../mutations/useAddSchoolBreak'

const routeApi = getRouteApi('/_auth/school-settings/breaks/add')

const defaultValues: DefaultValues<SchoolBreakFormPayload> = {
  name: '',
  dates: {
    from: undefined,
    to: undefined
  }
}

const SchoolYearAddView = () => {
  const navigate = routeApi.useNavigate()
  const { t } = useTranslation(['schoolSettings', 'common'])

  const {
    mutate: addSchoolBreak,
    isPending: isAddSchooBreakPending,
    formErrors
  } = useAddSchooBreak({
    onSuccess: response => {
      toast({
        variant: 'success',
        title: t('toast.school-break-add-success')
      })
      queryClient.invalidateQueries({
        queryKey: ['panelSchoolBreaksList']
      })
      navigate({
        to: '/school-settings/breaks/$breakId',
        params: {
          breakId: response.id
        }
      })
    },
    onError: () => {
      toast({
        variant: 'error',
        title: t('toast.school-break-add-error')
      })
    }
  })

  return (
    <BasicLayout
      breadcrumbs={[
        {
          title: t('common:navigation.school-settings'),
          to: '/school-settings'
        },
        {
          title: t('header.add-new-school-break')
        }
      ]}
      header={t('header.add-new-school-break')}
      moduleName={t('common:header.administration')}
    >
      <Loading spinning={isAddSchooBreakPending}>
        <SchoolBreakForm
          defaultValues={defaultValues}
          onSubmit={addSchoolBreak}
          errors={formErrors}
        />
      </Loading>
    </BasicLayout>
  )
}

export default SchoolYearAddView
